import { sub } from 'date-fns';

export function localTimeToUTC(date: Date): Date {
  const offset = date.getTimezoneOffset();
  return sub(date, { minutes: offset });
}
